(function () {
  var FREE_GIFT_THRESHOLD_CENTS = 29900;
  var GIFT_OPTIONS = [
    { variantId: 51103325126692, code: 'T1', name: 'Toner' },
    { variantId: 51103324799012, code: 'MA1', name: 'Mask' },
  ];
  var busy = false;
  var requestId = 0;

  function formatMoney(cents) {
    return 'RM' + (cents / 100).toFixed(2);
  }

  function getContainers() {
    return document.querySelectorAll('.lb-free-gift-banner');
  }

  function render(html) {
    getContainers().forEach(function (el) {
      el.innerHTML = html;
    });
  }

  function bindButtons() {
    getContainers().forEach(function (el) {
      el.querySelectorAll('[data-lb-gift-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addGift(parseInt(btn.getAttribute('data-lb-gift-add'), 10));
        });
      });
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) {
      return r.json();
    });
  }

  function syncAfterMutation() {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return Promise.resolve();
    }
    return refresh(true);
  }

  function addGift(variantId) {
    if (busy) return;
    busy = true;
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _free_gift: 'true' } }],
      }),
    })
      .then(function () {
        return syncAfterMutation();
      })
      .finally(function () {
        busy = false;
      });
  }

  function removeGiftLine(key) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function () {
        return syncAfterMutation();
      })
      .finally(function () {
        busy = false;
      });
  }

  function refresh(broadcast) {
    var myRequestId = ++requestId;
    return fetchCart().then(function (cart) {
      if (myRequestId !== requestId) return; // a newer refresh superseded this one; discard stale result
      evaluate(cart);
      if (broadcast && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lb-free-gift', cartData: cart });
      }
    });
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties._free_gift === 'true');
  }

  function evaluate(cart) {
    if (cart.items.length === 0) {
      render('');
      return;
    }

    var giftLines = cart.items.filter(isGiftLine);
    var nonGiftSubtotal = cart.items
      .filter(function (item) {
        return !isGiftLine(item);
      })
      .reduce(function (sum, item) {
        return sum + item.line_price;
      }, 0);

    if (nonGiftSubtotal >= FREE_GIFT_THRESHOLD_CENTS) {
      if (giftLines.length > 1) {
        removeGiftLine(giftLines[1].key);
        return;
      }
      if (giftLines.length === 1) {
        renderConfirmed(giftLines[0]);
      } else {
        renderPicker();
      }
    } else {
      if (giftLines.length > 0) {
        removeGiftLine(giftLines[0].key);
        return;
      }
      renderNudge(FREE_GIFT_THRESHOLD_CENTS - nonGiftSubtotal);
    }
  }

  function renderPicker() {
    var buttons = GIFT_OPTIONS.map(function (o) {
      return (
        '<button type="button" class="lb-free-gift-banner__btn" data-lb-gift-add="' +
        o.variantId +
        '">' +
        '<b>' + o.code + '</b> ' + o.name +
        '</button>'
      );
    }).join('');
    render(
      '<div class="lb-free-gift-banner__inner">' +
        '<p class="lb-free-gift-banner__title">You&rsquo;ve unlocked a free gift &mdash; choose one</p>' +
        '<div class="lb-free-gift-banner__options">' +
        buttons +
        '</div>' +
        '</div>'
    );
    bindButtons();
  }

  function renderConfirmed(giftLine) {
    render(
      '<div class="lb-free-gift-banner__inner lb-free-gift-banner__inner--confirmed">' +
        '<p class="lb-free-gift-banner__title">Free gift added: ' +
        giftLine.product_title +
        '</p>' +
        '</div>'
    );
  }

  function renderNudge(remainingCents) {
    if (remainingCents <= 0) {
      render('');
      return;
    }
    render(
      '<div class="lbr-rewards__gift is-locked">' +
        '<div class="lbr-rewards__gift-copy">' +
          '<strong>Complimentary gift locked</strong>' +
          '<span>Add ' + formatMoney(remainingCents) + ' more to unlock selection.</span>' +
        '</div>' +
      '</div>'
    );
  }

  function init() {
    refresh(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'lb-free-gift') return;
      refresh(false);
    });
  }
})();
